import { CredenciaisPayLoad } from "@cei-ufg/ngx-cei-sso-client";

export const credenciaisMapper: CredenciaisPayLoad = (customPayload: any) => {
    return {
        login: customPayload.usuario,
        password: customPayload.senha,
        redirect_url: customPayload.redirect_url,
        captcha_token: customPayload.captchaToken ?? customPayload.captcha_token,
    };
};
